import { EVC_WALLET_PAYMENT } from './constants';
import { getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse, loader, pageloader} from './utils';


export const walletReply = (walletReply) => {
    return {
      type: EVC_WALLET_PAYMENT,
      walletReply
    };  
};

export const evcwalletPayment = (params) => {
  
    return (dispatch, getState) => {
      const bodyFormData = new FormData();
      Object.keys(params).map(function(key, index) {
        bodyFormData.set(key, params[key]);
      });
      const headers = getAuthHeader();
      loader(true);
      postReq(`${apiURLPrefix}/payment/pay_through_evc_wallet`, bodyFormData , headers)
      .then(handleResponse) 
      .then((res) => {
        dispatch(walletReply(res));
      }).catch((err)=>{
        console.log(err);
      }) 
    }  
};